import { auth } from 'library/firebase/firebase';

export const CLOUD_URL = 'https://cloud.zezamii.com';

/**
 * Opens the new cloud dashboard (cloud.zezamii.com) in a new tab, passing the
 * current user's Firebase ID token so cloud can establish its own auth session
 * without asking the user to log in again.
 *
 * Mirrors the Rooms handoff (see openRooms.js): cloud's checkAuthorization saga
 * reads the inbound `?token=`, exchanges it via /v4/auth/exchange-token and
 * signs in with the returned custom token.
 *
 * When there is no authenticated user (e.g. the login screen), it falls back to
 * a plain open so the button still works — cloud just shows its own login.
 *
 * Usage:  openCloud()          → opens cloud at its default route
 *         openCloud('/some/path')  → opens a specific page
 */
const openCloud = async (path = '/') => {
	const user = auth.currentUser;

	// Not logged in (signin screen) — nothing to hand off, just open cloud.
	if (!user) {
		window.open(CLOUD_URL, '_blank', 'noopener,noreferrer');
		return;
	}

	try {
		const idToken = await user.getIdToken();
		const url = new URL(path, CLOUD_URL);
		url.searchParams.set('token', idToken);
		window.open(url.toString(), '_blank');
	} catch (e) {
		// Token fetch failed — still let the user reach cloud (they can log in there).
		window.open(CLOUD_URL, '_blank', 'noopener,noreferrer');
	}
};

export default openCloud;
